import React, { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';
import classnames from 'classnames';
import StoryblokClient from 'storyblok-js-client';
import RichTextResolver from 'storyblok-js-client/source/richTextResolver';

import richTextSchema from '../../rich-text-schema/richTextSchema';
import { useBankProducts } from '../context/BankProductsContext';
import { replaceCustomVars, varRegExp } from '../utils/replaceCustomVar';

export interface RichTextProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
  className?: string;
}

const storyblok = new StoryblokClient({});

storyblok.richTextResolver = new RichTextResolver(richTextSchema);

export const RichText: FunctionComponent<PropsWithChildren<RichTextProps>> = ({ content, className }) => {
  const richText = storyblok.richTextResolver.render(content) as unknown as string;
  const { contextProducts } = useBankProducts();
  const [html, setHtml] = useState(richText);

  useEffect(() => {
    if (varRegExp.test(html)) {
      setHtml(replaceCustomVars(html, contextProducts));
    }
  }, [contextProducts, html]);

  if (!content) {
    return null;
  }

  return <div className={classnames('sb-richtext', className)} dangerouslySetInnerHTML={{ __html: html }} />;
};
